import { render, staticRenderFns } from "./projectKanban.vue?vue&type=template&id=484b4583&scoped=true"
import script from "./projectKanban.vue?vue&type=script&lang=js"
export * from "./projectKanban.vue?vue&type=script&lang=js"
import style0 from "./projectKanban.vue?vue&type=style&index=0&id=484b4583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b4583",
  null
  
)

export default component.exports